import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { PlusIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { SectionHeading } from "./SectionHeading";
import { faqs } from "../data/landing";
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-white px-4 py-16 sm:py-20" aria-labelledby="faq" data-id="element-129" data-mp="1ge8vool0cht0">
      <div className="mx-auto max-w-3xl" data-id="element-130" data-mp="2dzeo1qok7hm2">
        <SectionHeading tone="light" title={<span id="faq" data-id="element-132" data-mp="290tnfq5eavx3">Frequently asked questions</span>} data-id="element-131" data-mp="2dyd7j6ory2wy" />

        <ul className="divide-y divide-slate-200 border-y border-slate-200" data-id="element-133" data-mp="28za2hm8snwoz">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <li key={f.q} data-id="element-134" data-mp="1z2njz43xxhq4" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 py-5 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-cyan" data-id="element-135" data-mp="1z5jhwsfsg6ek">
                  <span className="text-[17px] font-bold leading-snug text-ink" data-id="element-136" data-mp="uhke5scl9g26">{f.q}</span>
                  <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-[transform,background-color] duration-200 ease-out ${isOpen ? "rotate-45 bg-ink text-gold" : "bg-slate-100 text-ink"}`} data-id="element-137" data-mp="fk9u3ulvr1uu">
                    <PlusIcon className="h-5 w-5" aria-hidden="true" data-id="element-138" data-mp="bies0nw4kkg0" />
                  </span>
                </button>
                <AnimatePresence initial={false} data-id="element-139" data-mp="3szzdg5d69ypv">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: "auto",
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-140" data-mp="1tetf5ljbr2c">
                      <p className="pb-5 pr-10 text-[16px] leading-relaxed text-slate-600" data-id="element-141" data-mp="1pq4haj4128vv">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>

        <div className="mt-12 rounded-3xl bg-ink px-4 py-10" data-id="element-142" data-mp="1fszr88729t9s">
          <CtaButton label="I'm ready — get my Blueprint" data-id="element-143" data-mp="2dfp4xfb4lubh" />
        </div>
      </div>
    </section>;
}